import { render, staticRenderFns } from "./BooleanTableCell.vue?vue&type=template&id=4e8bb35e&scoped=true&"
import script from "./BooleanTableCell.vue?vue&type=script&lang=js&"
export * from "./BooleanTableCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8bb35e",
  null
  
)

export default component.exports